import React from 'react';

const ModalMenuPrimary = () => {
    return (
        <nav className="menu-primary">
            <ul className="nav">
                <li className={ "nav-item" + (window.location.pathname === '/' ? " current-nav-item" : "") }>
                    <a title="Hem" href={ process.env.PUBLIC_URL + "/" }>Hem</a>
                </li>

                <li className={ "nav-item" + (window.location.pathname === '/bookings' ? " current-nav-item" : "") }>
                    <a title="Bokningar" href={ process.env.PUBLIC_URL + "/bookings" }>Boka tid</a>
                </li>

                <li className={ "nav-item" + (window.location.pathname === '/about' ? " current-nav-item" : "") }>
                    <a title="About us" href={ process.env.PUBLIC_URL + "/about-us" }>Om oss</a>
                </li>

                <li className={ "nav-item" + (window.location.pathname === '/services-inside' ? " current-nav-item" : "") }>
                    <a title="services-inside" href={ process.env.PUBLIC_URL + "/services-inside" }>Priser</a>
                </li>

                <li className={ "nav-item" + (window.location.pathname === '/services' ? " current-nav-item" : "") }>
                    <a title="Services" href={ process.env.PUBLIC_URL + "/services" }>Tjänster</a>
                </li>

                <li className={ "nav-item" + (window.location.pathname === '/gallery' ? " current-nav-item" : "") }>
                    <a title="Gallery" href={ process.env.PUBLIC_URL + "/gallery" }>Galleri</a>
                </li>

                <li className={ "nav-item" + (window.location.pathname === '/contacts' ? " current-nav-item" : "") }>
                    <a title="Contacts" href={ process.env.PUBLIC_URL + "/contacts" }>Kontakt</a>
                </li>
            </ul>
        </nav>
    );
};

export default ModalMenuPrimary;
